import { authenticatedApiFetch } from '../../common/helpers';
import { call } from 'actionware';

export function toggleWithdrawalModal() { }

export function setFailedWithdrawal() { }

export function setOtherForm(data) {
  return data
}

export function createWithdrawal(data) {
  const withdrawData = {
    amount: data.amount,
    // lenderAccountId: data.lenderAccountId,
    userId: data.userId
  }
  setFailedWithdrawal()
  if (Number.isInteger(data.bankAccountId) && data.bankAccountId !== 'other') {
    Object.assign(withdrawData, {
      bankAccountId: data.bankAccountId,
      bankDetail: {
        bankAccount: data.bankAccount
      }
    })
  } else {
    Object.assign(withdrawData, {
      bankDetail: {
        bankName: data.bank,
        bankAccount: data.bankAccountNumber,
        bankAccountHolder: data.bankAccountHolder,
        city: data.city,
        branchName: data.branch,
        userId: data.userId
      }
    })
  }
  return authenticatedApiFetch(`account/withdraw/${data.lenderAccountId}`, 'POST', withdrawData).catch(
    call(setFailedWithdrawal)
  )
}
